import { Pipe, PipeTransform } from '@angular/core';

type SubType<T, Condition> = Pick<T, { [Key in keyof T]: T[Key] extends Condition ? Key : never }[keyof T]>;

@Pipe({
  name: 'filterObj',
})
export class FilterObjPipe implements PipeTransform {

  transform<T, K extends keyof SubType<T, string>>(value: T[] | null, propertyToObserve: K, filterValue: string): T[] | null {
    if (typeof propertyToObserve !== 'string') {
      throw new Error('[filterObj - pipe] Cannot use this pipe without a string');
    }
    if (typeof filterValue !== 'string') {
      throw new Error('[filterObj - pipe] Cannot use this pipe without a string');
    }

    if (!filterValue) { return value; }

    const values = value && value.filter((v) => {
      const cast = String(v[propertyToObserve]).toLowerCase(); // TODO: Remove this cast
      return (cast.includes(filterValue.toLowerCase()));
    });
    return values;
  }

}
